import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { ThemeUiActions } from '../actions';
import { ThemeName } from '../actions/theme-ui.actions';
import { ThemeState } from '../reducers/theme.reducer';
import * as ThemeSelector from '../selectors/theme.selectors';

@Injectable({
  providedIn: 'root',
})
export class ThemeFacade {
  theme$;
  isDark$;

  constructor(public store: Store<ThemeState>) {
    this.theme$ = this.store.select(ThemeSelector.selectTheme);
    this.isDark$ = this.store.select(ThemeSelector.selectIsDark);
  }

  public setTheme(theme: ThemeName) {
    this.store.dispatch(ThemeUiActions.SetTheme({ theme }));
  }

  public toggleTheme() {
    this.store.dispatch(ThemeUiActions.ToggleTheme());
  }

  public setSystemPreference(prefersDark: boolean) {
    this.store.dispatch(ThemeUiActions.SetSystemPreference({ prefersDark }));
  }
}
